export default {
  data() {
    return {
      news: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    getPublication(id) {
      this.$router.push(`/publication/${id}`);
    },
  },
  async mounted() {
    this.user && await this.$store.dispatch('news/GetNews', {
      profile_id: this.user.profile_id,
    })
      .then(({ news }) => {
        this.$set(this.$data, 'news', news);
      });
  },
};
